import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { addOnsStartupStartupFlowDefinition } from "../Addons/AddOnsStartup";
import { passengerDetailsStepDefinition } from "./PassengerDetailsFlow/PassengerDetailsStartupFlow";
import { paymentStartupFlowDefinition } from "./Payment/PaymentStartup";
import { seatingMapStartupFlowDefinition } from "./SeatingMap/SeatingMapStartup";
import { checkoutInitStepDefinition } from "./Steps/CheckoutInitStep";
import { CheckoutTransition } from "./Transition/CheckoutTransition";
import { voucherStartupFlowDefinition } from "./Voucher/VoucherStartup";


export const checkoutStartupFlow = new FlowDefinition("CheckoutFlow");

checkoutStartupFlow.addStep(checkoutInitStepDefinition);
checkoutStartupFlow.addStep(passengerDetailsStepDefinition);
checkoutStartupFlow.addStep(voucherStartupFlowDefinition);
checkoutStartupFlow.addStep(seatingMapStartupFlowDefinition);
checkoutStartupFlow.addStep(paymentStartupFlowDefinition);
checkoutStartupFlow.addStep(addOnsStartupStartupFlowDefinition);

///DEMO:: TEMP ADD TICKET DETAILS FOR DEMO
// checkoutStartupFlow.addStep(ticketDetailStartupFlowDefinition);

checkoutStartupFlow.addLink("CheckoutInit_Step", "PassengerDetailsFlow");
checkoutStartupFlow.addLink("CheckoutInit_Step", "VoucherFlow");
checkoutStartupFlow.addLink("CheckoutInit_Step", "SeatingMapFlow");
checkoutStartupFlow.addLink("CheckoutInit_Step", "PaymentFlow");
checkoutStartupFlow.addLink("CheckoutInit_Step", "AddOnsFlow");

///DEMO:: TEMP ADD TICKET DETAILS FOR DEMO
// checkoutStartupFlow.addLink("CheckoutInit_Step", "TicketDetailFlow");

checkoutStartupFlow.setStartStep("CheckoutInit_Step");

checkoutStartupFlow.addTransition(CheckoutTransition, "CheckoutInit_Step");

export const checkoutStepDefinition = new StepDefinition({
    stepName: "CheckoutFlow",
    stepFlow: checkoutStartupFlow,
    contextIsolation: false
})